import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './toolbar.component';
import { MaterialModuleWeb } from '../material/material.module';



@NgModule({
  declarations: [
    ToolbarComponent
  ],
  imports: [
    CommonModule,
    MaterialModuleWeb
  ],
  exports:[
    ToolbarComponent,
  ]
})
export class ToolbarModule { }
